// extracted by mini-css-extract-plugin
export default {"wrapper":"drop-zone_wrapper__mCHRR","banner_text":"drop-zone_banner_text__YbtcB","banner":"drop-zone_banner__2LOed","input":"drop-zone_input__y6OtI"};